import { backofficeAuth } from '../backofficeFirebaseClient';

const DEFAULT_FUNCTIONS_BASE = 'https://us-central1-acctoo-backoffice.cloudfunctions.net';

export const getBackofficeFunctionsBase = () =>
  (process.env.REACT_APP_BACKOFFICE_FUNCTIONS_URL || DEFAULT_FUNCTIONS_BASE).replace(/\/$/, '');

/**
 * Authenticated fetch to backoffice Cloud Functions API router (/api/v1/...).
 * @param {string} path e.g. '/v1/admins'
 */
export async function backofficeApiFetch(path, options = {}) {
  const token = await backofficeAuth.currentUser?.getIdToken?.();
  if (!token) throw new Error('Not signed in to backoffice');

  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  const url = `${getBackofficeFunctionsBase()}/api${normalizedPath}`;

  const res = await fetch(url, {
    ...options,
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
      ...(options.headers || {})
    }
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = json.error || json.message || res.statusText || `HTTP ${res.status}`;
    throw new Error(msg);
  }
  return json;
}
